module.exports = __webpack_public_path__ + "static/media/audio-icon.12a93ada.svg";